//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { IDirections } from '@models/IDirections';

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  title?: string;
  showIf?: boolean;
  offset?: IDirections<number>;
}

/**
 * The Indicator atom renders a small, "new" colored, inline
 * circle often used as a kind of notification telling the
 * user that something has changed.
 *
 * The atom uses relative positioning, so you can adjust its
 * position using the offset prop.
 */
const Indicator = ({ className, color, offset, showIf, title }: Props) => {
  return showIf ? (
    <IndicatorIcon
      className={className}
      color={color}
      offset={offset}
      title={title}
    />
  ) : null;
};

const IndicatorIcon = styled.div<{
  offset?: IDirections<number>;
  color?: string;
}>(
  ({ color, offset, theme }) => `
  display: inline-block;
  position: relative;
  background: ${color || theme.colors.mint5};
  height: ${theme.spacings[2]};
  width: ${theme.spacings[2]};
  top: ${offset?.top ?? 0}px;
  left: ${offset?.left ?? 0}px;
  bottom: ${offset?.bottom ?? 0}px;
  right: ${offset?.right ?? 0}px;
  border-radius: ${theme.borderRadii.pill};
`,
);

export default Indicator;
